import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'

@observer
class SkipOption extends Component {
    constructor(props) {
        super(props)
        this.existing_options = []
    }

    gridOptions = (question, setYOption, set1_index, page_question, page) => {
        const { addSkipOption, store } = this.props
        const { surveyLocale, survey } = store
        const { defaultLocale } = survey.metadata
        const { initialLocale } = page_question.question.metadata
        console.log('gridOptions')
        const key = `skip_option_${page_question.id}_${set1_index}`
        const options = page_question.question.optionSetX.options.map((setXOption, index) => {
            if (!this.existing_options.has(`${setYOption.id}|${setXOption.id}`)) {
                console.log(JSON.stringify(setYOption))
                let name = setYOption.getTitle(surveyLocale, defaultLocale, initialLocale)
                name = `${name} - ${setXOption.getTitle(surveyLocale, defaultLocale, initialLocale)}`
                const id = `skip_option_${page_question.id}_${set1_index}_${index}`
                return (
                    <div
                        key={id}
                        className="question_option skip-option-label"
                        onClick={() => addSkipOption({
                            setY: setXOption,
                            pageQuestionId: page_question.id,
                            setX: setYOption,
                        })}
                    >
                        {name}

                        <i
                            className="fal fa-circle-plus"
                        />
                    </div>
                )
            }
        })
        return (
            <div key={key}>{options}</div>
        )
    }

    getSGOptions = (pageQuestion) => {
        let options = []

        if (pageQuestion.question.optionSetY) {
            options = options.concat(pageQuestion.question.optionSetY.options.slice())
        }

        options = options.concat(pageQuestion.optionSetY.options.slice())
        return {
            options,
        }
    }

    render() {
        const {
            question,
            store,
            getExistingOptions,
            question_index,
            page_question,
            page,
            addSkipOption,
            addHasResponseOption,
            addNumericOption,
        } = this.props
        const { surveyLocale, survey } = store
        const { defaultLocale } = survey.metadata
        const { initialLocale } = page_question.question.metadata
        this.existing_options = getExistingOptions()
        let options = ''
        let hasOptions = false
        const { questionTypeCode } = page_question.question
        const isDoubleAxis = page_question.question.isDoubleAxis()
        const isSingleAxis = page_question.question.isSingleAxis()
        const isNumeric = ['I', 'PC'].includes(questionTypeCode)
        const isText = ['TX', 'TA', 'UV', 'TL'].includes(questionTypeCode)
        const isSmartGrid = questionTypeCode === 'SG'

        let optionSet = {
            options: [],
        }
        if (isSmartGrid) {
            optionSet = this.getSGOptions(page_question)
        } else if (isDoubleAxis) {
            optionSet = page_question.question.optionSetY
        } else if (isSingleAxis) {
            optionSet = page_question.question.optionSet
        }
        const questionOptions = optionSet.options.slice()

        if (!isNumeric && !isText && (isDoubleAxis || isSingleAxis || isSmartGrid)) {
            console.log(optionSet.options.slice())

            console.log(questionOptions)
            if (page_question.parentId) {
                const { parentId } = page_question
                const parentOptions = survey.pages.reduce((po, surveyPage) => {
                    if (surveyPage.questions) {
                        const pageQuestion = surveyPage.questions
                            .find((q) => q.id.toLowerCase() === parentId.toLowerCase())
                        if (pageQuestion) {
                            po = R.pathOr([], ['question', 'optionSet', 'options'], pageQuestion)
                        }
                    }
                    return po
                }, [])
                parentOptions.forEach((option) => {
                    const po = Object.assign(option, { parentId })
                    if (!po.isExclusive) {
                        questionOptions.push(po)
                    }
                })
            }

            options = questionOptions.map((option, index) => {
                if (!this.existing_options.has(option.id) && !option.isHidden) {
                    hasOptions = true
                    const id = `skip_option_${page_question.id}_${index}`
                    const isGrid = ['TB', 'RT', 'SG'].indexOf(page_question.question.questionTypeCode) > -1
                    return (
                        <div>
                            {!isGrid
                                && (
                                    <div
                                        key={id}
                                        className="question_option skip-option-label"
                                        onClick={() => addSkipOption({
                                            setY: option,
                                            pageQuestionId: page_question.id,
                                        })}
                                    >
                                        {option.getTitle(surveyLocale, defaultLocale, initialLocale)}

                                        <i
                                            className="fal fa-circle-plus"
                                        />
                                    </div>
                                )}
                            {isGrid
                                && this.gridOptions(question, option, index, page_question, page)}
                        </div>
                    )
                }
            })
            if (questionOptions === 0) {
                options = false
            }
        }

        if (isText) {
            const shortTitle = page_question.question.content.getTitleByLocale('shortTitle', store.surveyLocale, store.survey.metadata.defaultLocale)
            const elem = !this.existing_options.has(page_question.id)
                ? (
                    <div className="hah">
                        <p style={{ fontWeight: 'bold' }}>{shortTitle}</p>
                        <br />
                        <div>
                            <div>
                                <div
                                    key={`${`skip_option_${page_question.id}`}`}
                                >
                                    {questionOptions.map((option, index) => (
                                        <div
                                            key={option.id}
                                            className="question_option skip-option-label"
                                            onClick={() => addHasResponseOption({
                                                setY: option.id,
                                                pageQuestionId: page_question.id,
                                            })}
                                        >
                                            {option.getTitle(surveyLocale, defaultLocale, initialLocale)}

                                            <i
                                                className="fal fa-circle-plus"
                                            />
                                        </div>
                                    ))}

                                    {!isSingleAxis && (
                                        <div
                                            className="question_option skip-option-label"
                                            onClick={() => addHasResponseOption({ pageQuestionId: page_question.id })}
                                        >
                                            {shortTitle}

                                            <i
                                                className="fal fa-circle-plus"
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null
            return elem
        }

        if (['I'].includes(questionTypeCode)) {
            const elem = !this.existing_options.has(page_question.id)
                ? (
                    <div className="hah">
                        <p style={{ fontWeight: 'bold' }}>{page_question.question.content.getTitleByLocale('shortTitle', store.surveyLocale, store.survey.metadata.defaultLocale)}</p>
                        <br />
                        <div>
                            <div
                                key={`${`skip_option_${page_question.id}`}`}
                                className="question_option skip-option-label"
                                onClick={() => addNumericOption({
                                    pageQuestionId: page_question.id,
                                    equalityOperator: 'Eq',
                                    value: 0
                                })}
                            >
                                {i18n.t('skipLogicModal.hasResponse')}

                                <i
                                    className="fal fa-circle-plus"
                                />
                            </div>
                        </div>
                    </div>
                ) : null
            return elem
        }

        if (['PC'].includes(questionTypeCode)) {
            const elem = !this.existing_options.has(page_question.id)
                ? (
                    <div className="hah">
                        <p style={{ fontWeight: 'bold' }}>{page_question.question.content.getTitleByLocale('shortTitle', store.surveyLocale, store.survey.metadata.defaultLocale)}</p>
                        <br />
                        <div>
                            <div
                                key={`${`skip_option_${page_question.id}`}`}
                            >
                                {page_question.question.optionSet.options
                                    .map((option, index) => {
                                        const id = `skip_option_${page_question.id}_${index}`
                                        return (
                                            <div>
                                                <div
                                                    key={id}
                                                    className="question_option skip-option-label"
                                                    onClick={() => addNumericOption({
                                                        pageQuestionId: page_question.id,
                                                        equalityOperator: 'Eq',
                                                        value: 0,
                                                        setY: option.id,
                                                    })}
                                                    style={{
                                                        marginBottom: 5,
                                                    }}
                                                >
                                                    {option.getTitle(surveyLocale, defaultLocale, initialLocale)}

                                                    <i
                                                        className="fal fa-circle-plus"
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })}
                            </div>
                        </div>
                    </div>
                ) : null
            return elem
        }

        if (hasOptions === false) {
            return <div />
        }

        return (
            <div className="hah">
                <br />

                <p style={{ fontWeight: 'bold' }}>{page_question.question.content.getTitleByLocale('shortTitle', store.surveyLocale, store.survey.metadata.defaultLocale)}</p>

                <br />

                {options.map((opt) => (
                    <div style={{ marginBottom: 5 }}>
                        {opt}
                    </div>
                ))}
            </div>
        )
    }
}

export default SkipOption
